<template>
	<div class="card-body border-top pt-3">
		<btn-price-switch @updateFilter="updatePayment()" />
		<div
			class="body-price body-price-fixed"
			v-if="this.$store.state.price.filter === 'fixed'"
		>
			<form-select-range
				label="Kaufpreis"
				range-mode="price-consumerPriceGross"
				@updateFilter="this.$emit('updateFilter')"
			>
			</form-select-range>
		</div>
		<div v-else class="body-price">
			<div class="price-group form-group mb-4">
				<label class="mb-3 form-label">Wunschrate pro Monat</label>
				<Slider
					v-model="this.$store.state.price.rate"
					class="cm-range-slider slider-primary slider-fit slider-ltr slider-horizontal slider-txt-dir-ltr mt-2"
					:class="{
						active:
							this.$store.state.price.rate[0] !== minRate ||
							this.$store.state.price.rate[1] !== maxRate,
					}"
					:merge="slider.options.merge"
					:options="slider.options"
					:format="slider.format"
					showTooltip="focus"
					tooltipPosition="top"
					lazy
					@update="updateFilterRange()"
				/>
			</div>
			<div class="row gx-1 align-items-center">
				<div class="col">
					<select
						class="form-select"
						:class="{ active: hasRateFrom }"
						v-model="this.$store.state.price.rate[0]"
						@change="setRateFrom()"
					>
						<template v-for="range in rateRange" :key="range">
							<option
								v-if="
									range !== maxRate && this.$store.state.price.rate[1] > range
								"
								:value="range"
							>
								{{ getPrice(range) }} €
							</option>
						</template>
					</select>
				</div>
				<div class="col-auto text-center">-</div>
				<div class="col">
					<select
						class="form-select"
						:class="{ active: hasRateTo }"
						v-model="this.$store.state.price.rate[1]"
						@change="setRateTo()"
					>
						<template v-for="range in rateRange" :key="range">
							<option
								v-if="
									range !== minRate && this.$store.state.price.rate[0] < range
								"
								:value="range"
							>
								{{ getPrice(range) }} €
							</option>
						</template>
					</select>
				</div>
			</div>
			<div class="form-group mt-2">
				<label>Beliebte Raten</label>
				<div class="row g-2">
					<div class="col-6">
						<btn-rate-select
							:rate-from="this.$store.state.price.rate[0]"
							:rate-to="this.$store.state.price.rate[1]"
							:select-from="0"
							:select-to="200"
							@select-rate="selectRate"
						/>
					</div>
					<div class="col-6">
						<btn-rate-select
							:rate-from="this.$store.state.price.rate[0]"
							:rate-to="this.$store.state.price.rate[1]"
							:select-from="200"
							:select-to="300"
							@select-rate="selectRate"
						/>
					</div>
					<div class="col-6">
						<btn-rate-select
							:rate-from="this.$store.state.price.rate[0]"
							:rate-to="this.$store.state.price.rate[1]"
							:select-from="300"
							:select-to="400"
							@select-rate="selectRate"
						/>
					</div>
					<div class="col-6">
						<btn-rate-select
							:rate-from="this.$store.state.price.rate[0]"
							:rate-to="this.$store.state.price.rate[1]"
							:select-from="400"
							:select-to="500"
							@select-rate="selectRate"
						/>
					</div>
				</div>
			</div>
			<div
				v-if="this.$store.state.price.filter === 'finance'"
				class="text-price"
			>
				<p class="text-wrap">
					{{ getLegalTextFinanceFilter(showTextFinance) }}
					<a
						v-if="!showTextFinance"
						class="link-primary text-nowrap"
						href="#"
						@click.prevent="showTextFinance = true"
						>Mehr anzeigen<i class="mdi mdi-chevron-down"></i
					></a>
					<a
						v-else
						href="#"
						class="text-nowrap link-primary"
						@click.prevent="showTextFinance = false"
						>Weniger anzeigen<i class="mdi mdi-chevron-up"></i
					></a>
				</p>
			</div>
			<div v-else class="text-price">
				<p class="text-wrap">
					{{ getLegalTextLeasingFilter(showTextLeasing) }}
					<a
						v-if="!showTextLeasing"
						class="link-secondary text-nowrap"
						href="#"
						@click.prevent="showTextLeasing = true"
						>Mehr anzeigen<i class="mdi mdi-chevron-down"></i
					></a>
					<a
						v-else
						href="#"
						class="text-nowrap link-secondary"
						@click.prevent="showTextLeasing = false"
						>Weniger anzeigen<i class="mdi mdi-chevron-up"></i
					></a>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import BtnPriceSwitch from '@/components/ui/btn/BtnPriceSwitch'
import FormSelectRange from '@/components/ui/form/FormSelectRangeFilter'
import Slider from '@vueform/slider'
import BtnRateSelect from '@/components/ui/btn/BtnRateSelect'
import store from '@/store'

export default {
	name: 'RangePriceRate',
	components: {
		BtnPriceSwitch,
		BtnRateSelect,
		FormSelectRange,
		Slider,
	},
	data() {
		return {
			minRate: 0,
			maxRate: 600,
			showTextFinance: false,
			showTextLeasing: false,
			slider: {
				rate: [0, 600],
				format: {
					suffix: ' €',
					decimals: 0,
					thousand: '.',
				},
				options: {
					merge: 150,
					margin: 10,
					step: 10,
					range: {
						min: 0,
						max: 600,
					},
				},
			},
		}
	},
	computed: {
		hasRateFrom() {
			return !(
				store.state.filterItems[
					'range-from-darmasDeLeasing-rates-grossRateNum'
				] === undefined &&
				store.state.filterItems['range-from-financing-monthlyInstallment'] ===
					undefined &&
				store.state.price.rate[0] === this.minRate
			)
		},
		hasRateTo() {
			return !(
				store.state.filterItems[
					'range-till-darmasDeLeasing-rates-grossRateNum'
				] === undefined &&
				store.state.filterItems['range-till-financing-monthlyInstallment'] ===
					undefined &&
				store.state.price.rate[1] === this.maxRate
			)
		},
		sliderRange() {
			return [this.minRate, this.maxRate]
		},
		rateRange() {
			let range = []
			for (let i = 0; i <= this.maxRate; i = i + 10) {
				range.push(i)
			}
			return range
		},
	},
	methods: {
		selectRate(minRate, maxRate) {
			store.state.price.rate[0] = minRate
			store.state.price.rate[1] = maxRate
			this.updateFilterRange()
		},
		setRateFrom() {
			/*			if (
				this.slider.rate[0] > this.slider.rate[1] &&
				this.slider.rate[1] !== this.minRate
			) {
				this.slider.rate[1] = this.maxRate
			}*/
			this.updateFilterRange()
		},
		setRateTo() {
			/*			if (
				this.slider.rate[0] > this.slider.rate[1] &&
				this.slider.rate[1] !== this.maxRate
			) {
				this.slider.rate[0] = this.minRate
			}*/
			this.updateFilterRange()
		},
		updatePayment() {
			this.resetRangeFilter()

			if (store.state.price.filter === 'finance') {
				store.commit(
					'deleteFilter',
					'range-from-darmasDeLeasing-rates-grossRateNum'
				)
				store.commit(
					'deleteFilter',
					'range-till-darmasDeLeasing-rates-grossRateNum'
				)
			} else if (store.state.price.filter === 'leasing') {
				store.commit('deleteFilter', 'range-from-financing-monthlyInstallment')
				store.commit('deleteFilter', 'range-till-financing-monthlyInstallment')
			} else {
				store.commit('deleteFilter', 'range-from-financing-monthlyInstallment')
				store.commit('deleteFilter', 'range-till-financing-monthlyInstallment')
				store.commit(
					'deleteFilter',
					'range-from-darmasDeLeasing-rates-grossRateNum'
				)
				store.commit(
					'deleteFilter',
					'range-till-darmasDeLeasing-rates-grossRateNum'
				)
			}
			this.$emit('updateFilter')
		},
		updateFilterRange() {
			let keyTo = ''
			let keyFrom = ''

			if (store.state.price.filter === 'finance') {
				keyTo = 'range-till-financing-monthlyInstallment'
				keyFrom = 'range-from-financing-monthlyInstallment'
			} else if (store.state.price.filter === 'leasing') {
				keyTo = 'range-till-darmasDeLeasing-rates-grossRateNum'
				keyFrom = 'range-from-darmasDeLeasing-rates-grossRateNum'
			}

			// UPDATE FROM

			if (this.minRate !== store.state.price.rate[0]) {
				const filterItem = {
					adPropertyKey: keyFrom,
					adPropertyValue: store.state.price.rate[0],
					adPropertyType: 'number',
				}
				store.commit('updateFilter', filterItem)
			} else {
				store.commit('deleteFilter', keyFrom)
			}

			// UPDATE TILL/TO

			if (this.maxRate !== store.state.price.rate[1]) {
				const filterItem = {
					adPropertyKey: keyTo,
					adPropertyValue: store.state.price.rate[1],
					adPropertyType: 'number',
				}
				store.commit('updateFilter', filterItem)
			} else {
				store.commit('deleteFilter', keyTo)
			}

			this.$emit('updateFilter')
		},
		resetRangeFilter() {
			store.state.price.rate[0] = this.minRate
			store.state.price.rate[1] = this.maxRate
		},
	},
	created() {
		if (
			store.state.filterItems['range-from-financing-monthlyInstallment'] ||
			store.state.filterItems['range-to-financing-monthlyInstallment']
		) {
			store.state.price.filter = 'finance'
		}

		if (store.state.filterItems['range-from-financing-monthlyInstallment']) {
			this.selected.from =
				store.state.filterItems[
					'range-from-financing-monthlyInstallment'
				].adPropertyValue
			store.state.price.rate[0] =
				store.state.filterItems[
					'range-from-financing-monthlyInstallment'
				].adPropertyValue
		}
		if (store.state.filterItems['range-till-financing-monthlyInstallment']) {
			this.selected.to =
				store.state.filterItems[
					'range-till-financing-monthlyInstallment'
				].adPropertyValue
			store.state.price.rate[1] =
				store.state.filterItems[
					'range-till-financing-monthlyInstallment'
				].adPropertyValue
		}
	},
}
</script>

<style lang="scss" scoped>
.body-price {
	.price-group {
		margin-bottom: $px8;

		.lbl {
			font-size: $px14;
			margin-bottom: 0;
			display: block;
			color: $gray-600;
		}

		.price {
			font-size: $px16;
			line-height: $px18;
			display: block;
			font-weight: 500;
			margin-bottom: $px2;
		}
	}
}

.text-price {
	p {
		margin-bottom: 0;
		color: $gray-550;
		font-size: $px11;
	}
}

.input-group {
	&.active {
		> input,
		span {
			border-color: $primary;
		}
	}
}

.card-body-price {
	padding: 0 !important;

	.price-tabs {
		width: 100%;

		border-left: 1px solid #fff;
		border-right: 1px solid #fff;

		.tab-link {
			text-align: center;
			display: inline-block;

			width: 50%;
			color: #fff;
			padding: 0.4rem 0;
			border-top: 3px solid #fff;
			font-weight: 500;

			&.link-kaufpreis {
				border-right: 1px solid #fff;
				background-color: $success;

				&.active {
					border-top-color: $success;
				}
			}

			&.link-monatsrate {
				background-color: $danger;

				&.active {
					border-top-color: $danger;
				}
			}
		}
	}
}
</style>
